/** Shared with Sidebar.jsx's blue "new published signals" bell. Both the bell click
 *  AND the pages that actually show those signals (Signals.jsx, WeeklySignals.jsx)
 *  call markSignalsSeen so the badge clears whenever the user genuinely sees the new
 *  alerts — not only when they happen to click the bell itself to get there (e.g. via
 *  SignalTabsNav or a direct link instead). */
export function getSignalsLastSeenKey(user) {
  if (!user) return null;
  return `stockxignal_signals_last_seen_${user.id || user.email || 'anon'}`;
}

export function markSignalsSeen(user) {
  const key = getSignalsLastSeenKey(user);
  if (!key) return;
  localStorage.setItem(key, String(Date.now()));
  // Sidebar's poll runs every 30s; this lets it clear the badge immediately instead
  // of leaving a stale count showing for up to 30s after the user already saw it.
  window.dispatchEvent(new Event('sx-signals-seen'));
}
